import { CircularProgress } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import SurveyComplete from '../features/motive/motive-survey/survey-complete';
import SurveyError from '../features/motive/motive-survey/survey-error';
import SurveyImage from '../features/motive/motive-survey/survey-image';
import SurveyQuestionnaire from '../features/motive/motive-survey/survey-questionnaire';
import SurveyText from '../features/motive/motive-survey/survey-text';
import SurveyWelcome from '../features/motive/motive-survey/survey-welcome';
import { useSurveyFlow } from '../features/motive/motive-survey/use-survey-flow';

const MotiveSurvey: React.FC = () => {
  const { classes, cx } = useStyles();
  const {
    step,
    alreadyCompleted,
    isChecked,
    currentImage,
    currentText,
    allQuestionsAnswered,
    submissionError,
    missingQuestionIndexes,
    questionsApplyVersion,
    questionsImportanceVersion,
    selectedValue,
    handleChangeIsChecked,
    handleStartSurvey,
    handleWriteText,
    handleSaveTextAndNextImage,
    handleTextChange,
    handleTextKeyUp,
    handleTextKeyDown,
    selectionChangeHandlerGenerator,
    handleSendSurvey,
  } = useSurveyFlow();

  const renderStep = () => {
    switch (step) {
      case 'loading':
        return (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        );
      case 'error':
        return <SurveyError completed={alreadyCompleted} />;
      case 'complete':
        return <SurveyComplete />;
      case 'welcome':
        return <SurveyWelcome handleChangeIsChecked={handleChangeIsChecked} isChecked={isChecked} handleStartSurvey={handleStartSurvey} />;
      case 'questionnaire':
        return (
          <SurveyQuestionnaire
            selectedValue={selectedValue}
            allQuestionsAnswered={allQuestionsAnswered}
            submissionError={submissionError}
            missingQuestionIndexes={missingQuestionIndexes}
            questionsApplyVersion={questionsApplyVersion}
            questionsImportanceVersion={questionsImportanceVersion}
            selectionChangeHandlerGenerator={selectionChangeHandlerGenerator}
            handleSendButton={handleSendSurvey}
          />
        );
      case 'text':
        return (
          <SurveyText
            keyDown={handleTextKeyDown}
            keyUp={handleTextKeyUp}
            onTextChange={handleTextChange}
            nextStep={handleSaveTextAndNextImage}
            textValue={currentText}
          />
        );
      case 'image':
        return <SurveyImage image={currentImage} nextStep={handleWriteText} />;
      default:
        return null;
    }
  };

  return (
    <div className={classes.root}>
      <div className={cx(classes.contentStatic, classes.content)}>{renderStep()}</div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
  },
  content: {
    padding: theme.spacing(3),
    width: '100%',
    overflow: 'hidden',
  },
  contentStatic: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
  },
}));

export default MotiveSurvey;

// Re-export types for child components
export type { OrderedQuestion, CheckBox } from '../features/motive/motive-survey/use-survey-flow';
